import { render, staticRenderFns } from "./puppy-purchase-details-container.vue?vue&type=template&id=16b92572&scoped=true&lang=pug"
import script from "./puppy-purchase-details-container.js?vue&type=script&lang=js&external"
export * from "./puppy-purchase-details-container.js?vue&type=script&lang=js&external"
import style0 from "./puppy-purchase-details-container.vue?vue&type=style&index=0&id=16b92572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b92572",
  null
  
)

export default component.exports